export const launcherModules = [
  {
    id: 'dashboard',
    command: 'dashboard',
    aliases: ['dashboard', 'tablero', 'overview'],
    titleKey: 'MAIN.DASHBOARD',
    link: '/dashboard',
    icon: 'chart-pie',
    requiredPermission: 'dashboard.view',
    modes: ['gestion'],
    keywords: ['dashboard', 'tablero', 'resumen', 'metricas']
  },
  {
    id: 'analisis',
    command: 'analisis',
    aliases: ['analisis', 'analysis', 'insights', 'metricas'],
    titleKey: 'MAIN.ANALISIS',
    link: '/analisis',
    icon: 'chart-line',
    requiredPermission: 'analisis.view',
    modes: ['gestion'],
    keywords: ['analisis', 'metricas', 'insights', 'performance']
  },
  {
    id: 'posts',
    command: 'publicaciones',
    aliases: ['publicaciones', 'productos', 'items', 'catalogo', 'posts'],
    titleKey: 'MAIN.POSTS',
    link: '/posts',
    icon: 'file-invoice',
    requiredPermission: 'posts.view',
    modes: ['gestion'],
    keywords: ['publicaciones', 'productos', 'items', 'catalogo', 'mercado libre']
  },
  {
    id: 'stock',
    command: 'stock',
    aliases: ['stock', 'inventario', 'depositos', 'almacenes', 'warehouses'],
    titleKey: 'MAIN.STOCK',
    link: '/stock',
    icon: 'box',
    requiredPermission: 'stock.view',
    modes: ['gestion'],
    keywords: ['stock', 'inventario', 'ubicaciones', 'depositos', 'warehouses']
  },
  {
    id: 'agents',
    command: 'agentes',
    aliases: ['agentes', 'bots', 'mapa', 'agents'],
    titleKey: 'MAIN.AGENTS',
    link: '/agents',
    icon: 'robot',
    requiredPermission: 'agents.view',
    modes: ['gestion'],
    keywords: ['agentes', 'bots', 'mapa']
  },
  {
    id: 'integrations',
    command: 'integraciones',
    aliases: ['integraciones', 'conexion', 'integrations'],
    titleKey: 'MAIN.INTEGRATIONS',
    link: '/integrations',
    icon: 'plug',
    requiredPermission: 'integrations.view',
    modes: ['gestion'],
    keywords: ['integraciones', 'mercado libre', 'conexion']
  },
  {
    id: 'notifications',
    command: 'notificaciones',
    aliases: ['notificaciones', 'alertas', 'notifications'],
    titleKey: 'MAIN.NOTIFICATIONS',
    link: '/social/notifications',
    icon: 'bell',
    requiredAnyPermissions: [
      'notifications.view_internal',
      'notifications.view_mercadolibre',
      'notifications.view_questions'
    ],
    modes: ['gestion'],
    keywords: ['notificaciones', 'alertas']
  },
  {
    id: 'price-calculator',
    command: 'calculadora',
    aliases: ['calculadora', 'precio', 'margen', 'rentabilidad', 'price'],
    titleKey: 'MAIN.PRICE_CALCULATOR',
    link: '/price-calculator',
    icon: 'calculator',
    requiredPermission: 'price_calculator.view',
    modes: ['gestion'],
    keywords: ['calculadora', 'precio', 'margen', 'ganancia', 'mercado libre', 'comision']
  },
  {
    id: 'users',
    command: 'usuarios',
    aliases: ['usuarios', 'users'],
    titleKey: 'MAIN.USERS',
    link: '/users',
    icon: 'users',
    requiredPermission: 'users.view',
    modes: ['gestion'],
    keywords: ['usuarios']
  },
  {
    id: 'profiles',
    command: 'perfiles',
    aliases: ['perfiles', 'roles', 'profiles'],
    titleKey: 'MAIN.PROFILES',
    link: '/profiles',
    icon: 'user-circle',
    requiredPermission: 'profiles.view',
    modes: ['gestion'],
    keywords: ['perfiles', 'roles']
  },
  {
    id: 'questions',
    command: 'preguntas',
    aliases: ['preguntas', 'consultas', 'qa', 'questions'],
    titleKey: 'MAIN.QUESTIONS',
    link: '/questions',
    icon: 'question-circle',
    requiredPermission: 'questions.view',
    modes: ['gestion'],
    keywords: ['preguntas', 'qa', 'consultas']
  },
  {
    id: 'calendar',
    command: 'calendario',
    aliases: ['calendario', 'agenda', 'calendar'],
    titleKey: 'MAIN.CALENDAR',
    link: '/calendar',
    icon: 'calendar-alt',
    requiredPermission: 'calendar.view',
    modes: ['gestion'],
    keywords: ['calendario', 'agenda', 'operacion', 'eventos']
  },
  {
    id: 'activity',
    command: 'actividad',
    aliases: ['actividad', 'log', 'auditoria', 'activity'],
    titleKey: 'MAIN.ACTIVITY',
    link: '/activity',
    icon: 'list-alt',
    requiredPermission: 'activity.view',
    modes: ['gestion'],
    keywords: ['actividad', 'auditoria', 'acciones', 'log']
  },
  {
    id: 'messages',
    command: 'mensajes',
    aliases: ['mensajes', 'mensajeria', 'chats', 'messages'],
    titleKey: 'MAIN.MESSAGES',
    link: '/messages',
    icon: 'comments',
    requiredPermission: 'messages.view_internal',
    modes: ['gestion'],
    keywords: ['mensajes', 'mensajeria', 'interna', 'chats']
  },
  {
    id: 'ml-messages',
    command: 'ml-mensajes',
    aliases: ['ml', 'mensajes-ml', 'mercadolibre-messages', 'postventa'],
    titleKey: 'MAIN.ML_MESSAGES',
    link: '/mercadolibre-messages',
    icon: 'comment',
    requiredPermission: 'messages.view_mercadolibre',
    modes: ['gestion'],
    keywords: ['mensajes ml', 'mercado libre', 'postventa']
  },
  {
    id: 'sales',
    command: 'ventas',
    aliases: ['ventas', 'pedidos', 'sales', 'orders'],
    titleKey: 'MAIN.SALES',
    link: '/sales',
    icon: 'shopping-cart',
    requiredPermission: 'sales.view',
    modes: ['gestion'],
    keywords: ['ventas', 'pedidos', 'orders']
  },
  {
    id: 'claims',
    command: 'reclamos',
    aliases: ['reclamos', 'claims'],
    titleKey: 'MAIN.CLAIMS',
    link: '/claims',
    icon: 'exclamation-triangle',
    requiredPermission: 'claims.view',
    modes: ['gestion'],
    keywords: ['reclamos', 'claims']
  },
  {
    id: 'partners',
    command: 'partners',
    aliases: ['partners', 'partner', 'socios'],
    titleKey: 'PARTNERS.MENU',
    link: '/partners',
    icon: 'users',
    requiredPermission: 'partners.view',
    modes: ['partners'],
    keywords: ['partner', 'referrals', 'link']
  },
  {
    id: 'blog',
    command: 'blog',
    aliases: ['blog', 'contenido', 'posts-publicos'],
    titleKey: 'BLOG.MENU',
    link: '/blog',
    icon: 'pen-nib',
    requiredPermission: 'blog.view',
    modes: ['blog'],
    keywords: ['blog', 'contenido', 'landing']
  },
  {
    id: 'super-admin',
    command: 'superadmin',
    aliases: ['superadmin', 'super-admin', 'platform'],
    titleKey: 'SUPERADMIN.TITLE',
    link: '/super-admin',
    icon: 'crown',
    requiresSuperAdmin: true,
    modes: ['superadmin'],
    keywords: ['platform', 'companies', 'waitlist']
  },
  {
    id: 'subscription',
    command: 'suscripcion',
    aliases: ['suscripcion', 'plan', 'subscription', 'billing'],
    titleKey: 'MAIN.SUBSCRIPTION',
    link: '/subscription',
    icon: 'credit-card',
    requiredPermission: 'subscription.view',
    modes: ['gestion'],
    keywords: ['suscripcion', 'plan', 'limites', 'facturacion']
  },
  {
    id: 'sales-dashboard-workspace',
    command: 'sales-dashboard',
    aliases: ['sales-dashboard', 'crm-dashboard', 'dashboard-ventas'],
    titleKey: 'SALES.DASHBOARD',
    link: '/sales/dashboard',
    icon: 'chart-bar',
    requiredPermission: 'crm.view',
    modes: ['sales'],
    keywords: ['sales', 'dashboard', 'crm', 'opportunities']
  },
  {
    id: 'sales-pipeline-workspace',
    command: 'opportunities',
    aliases: ['opportunities', 'pipeline', 'kanban', 'deal-flow', 'oportunidades'],
    titleKey: 'SALES.OPPORTUNITIES',
    link: '/sales/pipeline',
    icon: 'columns',
    requiredPermission: 'pipeline.view',
    modes: ['sales'],
    keywords: ['opportunities', 'pipeline', 'deals', 'kanban', 'stages']
  },
  {
    id: 'sales-companies-workspace',
    command: 'companies',
    aliases: ['companies', 'empresas', 'accounts-crm'],
    titleKey: 'SALES.COMPANIES',
    link: '/sales/companies',
    icon: 'building',
    requiredPermission: 'crm.view',
    modes: ['sales'],
    keywords: ['companies', 'empresas', 'crm', 'accounts']
  },
  {
    id: 'sales-tasks-workspace',
    command: 'sales-tasks',
    aliases: ['sales-tasks', 'followups', 'crm-tasks'],
    titleKey: 'SALES.TASKS',
    link: '/sales/tasks',
    icon: 'tasks',
    requiredPermission: 'tasks.view',
    modes: ['sales'],
    keywords: ['tasks', 'follow-up', 'reminders', 'activity']
  },
    {
      id: 'sales-promo-workspace',
      command: 'sales-promo',
      aliases: ['sales-promo', 'promo', 'discount-codes'],
      titleKey: 'SALES.PROMO',
      link: '/sales/promo',
      icon: 'tags',
      requiredPermission: 'promo.view',
      modes: ['sales'],
      keywords: ['sales', 'promo', 'campaigns', 'codes', 'discounts']
    },
    {
      id: 'sales-reports-workspace',
      command: 'sales-reports',
      aliases: ['sales-reports', 'reports', 'metrics-sales'],
      titleKey: 'SALES.REPORTS',
      link: '/sales/reports',
      icon: 'chart-line',
      requiredPermission: 'sales_reports.view',
      modes: ['sales'],
      keywords: ['sales', 'reports', 'metrics', 'pipeline']
    },
  {
    id: 'sales-accounts-workspace',
    command: 'accounts-activate',
    aliases: ['accounts-to-activate', 'onboarding-accounts', 'activations'],
    titleKey: 'SALES.ACCOUNTS_TO_ACTIVATE',
    link: '/sales/accounts-to-activate',
    icon: 'user-check',
    requiredPermission: 'crm.view',
    modes: ['sales'],
    keywords: ['accounts', 'activate', 'onboarding', 'customer']
  }
];
